import { render } from "./ServiceJobComponentView.vue?vue&type=template&id=8b91598e&scoped=true&ts=true"
import script from "./ServiceJobComponentView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobComponentView.vue?vue&type=script&lang=ts"

import "./ServiceJobComponentView.vue?vue&type=style&index=0&id=8b91598e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b91598e"]])

export default __exports__